import {BackendError} from './backend-error';

export class UnavailableArchiveError extends BackendError {}
